import 'material-design-icons-iconfont/dist/material-design-icons.css'
import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: 'md', // default - only for display purposes
  },
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        selection: '#FFC50B',
        'text-primary': '#211256',
        grey: '#DFE2E5',
        'grey-navy': '#656077',
        'text-grey': '#4F4F4F',
        'mid-grey': '#858585',
        'background-grey': '#F7F7F9',
        'font-color': '#2c3e50',
        'light-blue': '#F7F7F9',
        'complete-green': '#15b775',
        'non-compliant': '#fc4b8b',

        //vuetify defaults
        primary: "#211256",
        secondary: "#211256",
        error: "#FC3A64",
        info: "#4E4278",
        success: "#07A693",
        warning: "#C29400",
        "grey-info": "#747678",

        //primary colors
        white: "#FFFFFF",
        black: "#222",
        navy: "#211256",
        blue: "#4E4278",
        pink: "#FC3A64",
        red: "#FC3A64",
        yellow: "#FFC50B",
        green: "#2EB8A7",
        // grey: "#656077",
        "darker-grey": "#666666",
        "whatsapp-green": "#25D366",
        "facebook-blue": "#1877F2",
        
        //plans
        "jeff-life": "#2EB8A7",
        challenges: "#FFC50B",
        "one-on-one": "#F73A64",
        club: "#FFC50B",

        //dots
        exercise: "#FD89A2",
        nutrition: "#3ADEB4",
        mindset: "#FFD13C",
        sleep: "#968abd",
        hydration: "#60c8e8",
        rest: "#acaab2",

        //backgrounds
        "blue-background": "#D3D0DD",
        "grey-background": "#f4f4f4",
        "pink-background": "#FED7E0",
        "red-background": "#FED7E0",
        "yellow-background": "#FFF3CE",
        "green-background": "#D0F6F2",

        //icons
        "blue-icon": "#4E4278",
        "grey-icon": "#929496",
        "pink-icon": "#FC3A64",
        "red-icon": "#FC3A64",
        "yellow-icon": "#FFC509",
        "green-icon": "#16D3BC",
      }
    }
  }
});
